import  { useEffect, useState } from "react";
import AOS from "aos";
import "aos/dist/aos.css";
import { Swiper, SwiperSlide } from "swiper/react"; // Import Swiper and SwiperSlide
import "swiper/css"; // Core Swiper styles
import "swiper/css/effect-fade"; // Effect Fade styles
import "swiper/css/navigation"; // Navigation styles
import "swiper/css/pagination"; // Pagination styles
import "swiper/css/autoplay"; // Autoplay styles
import { EffectFade, Navigation, Autoplay, Pagination } from "swiper/modules"; // Import modules from swiper/modules
import Loader from "../../components/Loader/Loader";
import HeaderOne from "../../components/Header/HeaderOne";
import CTAOne from "../../components/CTA/CTAOne";
import FooterOne from "../../components/Footer/FooterOne";
import Gallery from "../../components/Gallery/Gallery";
import { Link, useParams } from "react-router-dom";
import DataFetcher from "../../components/DataFetcher/DataFetcher";
import { HashLink } from "react-router-hash-link";
import { EmailShareButton } from "react-share";
import FsLightbox from "fslightbox-react";
import FunFactsArchitecture2 from "../../components/FunFacts/FunFactsArchitecture2";
import { AiOutlineBorderBottom } from "react-icons/ai";
import { PiMapPinLineThin } from "react-icons/pi";
import { CiVideoOn } from "react-icons/ci";
import { CiCalculator1 } from "react-icons/ci";
import { PiPrinterThin } from "react-icons/pi";
import { PiShareNetworkLight } from "react-icons/pi";
import MortgageCalculator from "../../components/MortgageCalculator/MortgageCalculator";
import ReactPlayer from "react-player";

const Property = () => {
  const { id } = useParams(); // Extract the id from the URL
  const API_URL = `${process.env.REACT_APP_API_BASE_URL}?op=property&id=${id}`;
  const imageBaseUrl = process.env.REACT_APP_IMAGE_BASE_URL;
  const videoBaseUrl = process.env.REACT_APP_VIDEO_BASE_URL;
  const baseUrl = process.env.REACT_APP_BASE_URL;
  const defaultVideoUrl = `${videoBaseUrl}checkbacksoon.mp4`;
  const floorplanItem = "/large0.jpg";
  const [isOpen, setIsOpen] = useState(false);
  const [toggler, setToggler] = useState(false);
  const [toggler2, setToggler2] = useState(false);
  const [videoUrl, setVideoUrl] = useState(""); // Add this state

  const params = {
    navigation: {
      nextEl: ".portfolio-slider-next",
      prevEl: ".portfolio-slider-prev",
    },
    effect: "fade",
    autoplay: {
      delay: 2500,
    },
  };

  useEffect(() => {
    AOS.init();
    AOS.refresh();
  }, []);

  useEffect(() => {
    // Check if the video file exists before setting the videoUrl
    const testUrl = `${videoBaseUrl}${id}/a.mp4`;
    fetch(testUrl, { method: "HEAD" })
      .then((res) => {
        if (res.ok) {
          setVideoUrl(testUrl);
        } else {
          setVideoUrl(defaultVideoUrl);
        }
      })
      .catch(() => setVideoUrl(defaultVideoUrl));
  }, [id, videoBaseUrl, defaultVideoUrl]);

  return (
    <DataFetcher url={API_URL}>
      {(data) => {
        return (
          <Loader>
            <FsLightbox
              toggler={toggler}
              sources={[
                <img
                  src={`${imageBaseUrl}${data.WebId}/${floorplanItem}`}
                />,
              ]}
            />

            <FsLightbox
              toggler={toggler2}
              sources={[
                <div style={{ width: "100%", height: "100%" }}>
                  <ReactPlayer
                    url={videoUrl}
                    playing
                    controls
                    width="1024px"
                    height="768px"
                    onError={() => setVideoUrl(defaultVideoUrl)}
                  />
                </div>,
              ]}
            />

            <HeaderOne />
            <section className="pt-100 pt-100 mt-50">
              <div className="container">
                <div className="row">
                  <div className="col-md-9 portfolio-left">
                    <div className="portfolio-slider">
                      <Swiper
                        {...params}
                        modules={[EffectFade, Navigation, Autoplay, Pagination]} // Pass modules as props
                        pagination={{ clickable: true }}
                        navigation
                        loop={true}
                        grabCursor={true}
                        effect={"fade"}
                        autoplay={{ delay: 5000 }}
                        observer={true}
                        observeParents={true}
                        style={{
                          maxHeight: "610px",
                        }}
                      >
                        {data.Photos.slice(1).map((photo, index) => (
                          <SwiperSlide className="item" key={index}>
                            <div
                              className="slide-img"
                              style={{
                                backgroundImage: `url(${imageBaseUrl}${data.WebId}/${photo})`,
                                backgroundPosition: "center center",
                                backgroundSize: "cover",
                                backgroundRepeat: "no-repeat",
                                backgroundAttachment: "scroll",
                                maxHeight: "610px",
                              }}
                            ></div>
                          </SwiperSlide>
                        ))}
                      </Swiper>

                      <div className="row col-md-20">
                        <div className="col-md-2 mb-0 col-sm-1 icon-center-text">
                          {" "}
                          <h2 className="red-color icon-center">
                            <AiOutlineBorderBottom
                              size={42}
                              onClick={() => setToggler(!toggler)}
                            />
                          </h2>
                          FLOORPLAN
                        </div>
                        <div className="col-md-2 mb-0 col-sm-1 icon-center-text">
                          <HashLink to={`/property/${data.WebId}#streetview`}>
                            {" "}
                            <h2 className="red-color icon-center">
                              <PiMapPinLineThin size={42} />
                            </h2>
                          </HashLink>
                          MAP
                        </div>
                        <div className="col-md-2 mb-0 col-sm-1 icon-center-text">
                          <HashLink to={`/property/${data.WebId}#mortgage`}>
                            {" "}
                            <h2 className="red-color icon-center">
                              <CiCalculator1 size={42} />
                            </h2>
                          </HashLink>
                          MORTGAGE
                        </div>

                        <div className="col-md-2 mb-0 col-sm-1 icon-center-text">
                          <h2 className="red-color icon-center">
                            <CiVideoOn
                              size={42}
                              onClick={() => setToggler2(!toggler2)}
                            />
                          </h2>
                          VIRTUAL TOUR
                        </div>
                        <div className="col-md-2 mb-0 col-sm-1 icon-center-text">
                          <Link
                            to={`/property/${data.WebId}`}
                            onClick={() => {
                              window.print();
                            }}
                          >
                            <h2 className="red-color icon-center">
                              <PiPrinterThin size={42} />
                            </h2>
                          </Link>
                          PRINT
                        </div>
                        <div className="col-md-2 mb-0 col-sm-1 icon-center-text">
                          <h2 className="red-color icon-center">
                            <EmailShareButton
                              url={`${baseUrl}/property/${data.WebId}`}
                              subject={`${data.Address1}`}
                              body={
                                "Hi, I thought you might be interested in this property on the Olshan Realty website."
                              }
                            >
                              <PiShareNetworkLight size={42} />
                            </EmailShareButton>
                          </h2>
                          SHARE
                        </div>
                      </div>
                    </div>

                    {isOpen && (
                      <Lightbox
                        mainSrc={`${imageBaseUrl}${data.WebId}/large0.jpg`}
                        onCloseRequest={() => closeLightbox()}
                      />
                    )}
                    <h3>Property Description</h3>
                    <div className="mt-20" dangerouslySetInnerHTML={{ __html: data.Notes }} />

                    <h3>Building Notes</h3>
                    <div className="mt-20" dangerouslySetInnerHTML={{ __html: data.BldgNotes }} />
                    {data.Agents.map((agent, index) => (
                      <div className="container" columns="2" key={index}>
                        <div className="row left-red-bar">
                          <div>
                            <h4>Exclusive Agent</h4>
                          </div>
                          <div className="col-md-4 mb-20 col-sm-4 text-left float-left">
                            <img
                              src={`${imageBaseUrl}${agent.Image}`}
                              className="img-fluid member-thumb"
                              alt={agent.Name}
                            />
                          </div>

                          <div className="col-md-6 mb-0 col-sm-6">
                            <h4>{agent.Neighborhoodame}</h4>
                            <h5>{agent.Title}</h5>
                            <strong>Direct Phone:</strong>
                            {agent.Contact1}
                            <br />
                            <strong>Residence:</strong>
                            {agent.Contact3}
                            <br />
                            <strong>Fax:</strong>
                            {agent.Contact2}
                            <br />
                            <a href="mailto:{agent.Email}">{agent.Email}</a>
                            <div id="streetview"></div>
                            <p className="mt-20">
                              <Link
                                className="btn btn-color btn-rounded"
                                to={"/agent/" + agent.AgentId}
                              >
                                More About {agent.Name}
                              </Link>
                            </p>
                          </div>
                        </div>
                      </div>
                    ))}

                    <br />
                    <hr className="full" />
                    <div id="streetview"></div>
                    <section className="pt-0 mt-0">
                      <div className="row">
                        <h3>Street Map of {data.Address1}</h3>
                        <div className="item">
                          <br />
                          <iframe
                            width="100%"
                            height="500"
                            referrerPolicy="no-referrer-when-downgrade"
                            src={`https://www.google.com/maps/embed/v1/search?key=AIzaSyBjg_ZNdb52RA5m41tkeybhpNQMasn1D20&q=${data.Address1}&zoom=19&maptype=satellite`}
                            title="streetview"
                            allowFullScreen
                          ></iframe>
                        </div>
                      </div>
                    </section>

                    <hr className="full" />

                    <section className="pt-0 mt-0">
                      <div className="row">
                        <h3>Transit &amp; Walkability</h3>
                        <div className="item">
                          <br />

                          <iframe
                            width="100%"
                            height="600"
                            referrerPolicy="no-referrer-when-downgrade"
                            src={`https://api.olshan.com/api/ws.php?a=${data.Address1} New York, NY`}
                            title="walkscore"
                            allowFullScreen
                          ></iframe>
                        </div>
                      </div>
                    </section>

                    <hr className="full" />

                    <section className="pt-0 mt-0">
                      <div className="row">
                        <h3>Nearby Schools for zip {data.Zip}</h3>
                        <div className="item">
                          <br />

                          <iframe
                            width="100%"
                            height="500"
                            referrerPolicy="no-referrer-when-downgrade"
                            src={`https://www.google.com/maps/embed/v1/search?key=AIzaSyBjg_ZNdb52RA5m41tkeybhpNQMasn1D20&q=schools+in+${data.Zip}`}
                            title="schools"
                            allowFullScreen
                          ></iframe>
                        </div>
                      </div>
                    </section>

                    <hr className="full" />

                    <section className="pt-0 mt-0">
                      <div className="row">
                        <h3>Dining Out in zip {data.Zip}</h3>

                        <div className="item">
                          <br />
                          <iframe
                            width="100%"
                            height="500"
                            referrerPolicy="no-referrer-when-downgrade"
                            src={`https://www.google.com/maps/embed/v1/search?key=AIzaSyBjg_ZNdb52RA5m41tkeybhpNQMasn1D20&q=restaurants+and+bars+in+${data.Zip}`}
                            title="restaurants"
                            allowFullScreen
                          ></iframe>
                        </div>
                      </div>
                    </section>

                    <hr className="full" />

                    <section className="pt-0 mt-0">
                      <div className="row">
                        <h3>Shopping in zip {data.Zip}</h3>

                        <div className="item">
                          <br />
                          <iframe
                            width="100%"
                            height="500"
                            referrerPolicy="no-referrer-when-downgrade"
                            src={`https://www.google.com/maps/embed/v1/search?key=AIzaSyBjg_ZNdb52RA5m41tkeybhpNQMasn1D20&q=supermarkets+and+hardware+stores+and+shops+in+${data.Zip}`}
                            title="shopping"
                            allowFullScreen
                          ></iframe>
                        </div>
                      </div>
                    </section>

                    <hr className="full" />

                    <section className="pt-0 mt-0">
                      <div className="row">
                        <h3>Arts & Entertainment in zip {data.Zip}</h3>

                        <div className="item">
                          <br />
                          <iframe
                            width="100%"
                            height="500"
                            referrerPolicy="no-referrer-when-downgrade"
                            src={`https://www.google.com/maps/embed/v1/search?key=AIzaSyBjg_ZNdb52RA5m41tkeybhpNQMasn1D20&q=museums+and+theaters+music+movies+in+${data.Zip}`}
                            title="entertainment"
                            allowFullScreen
                          ></iframe>
                        </div>
                      </div>
                      <p className="legal">
                        <br />
                        All information regarding a property for sale, rental or
                        financing is from sources deemed reliable. No
                        representation is made as to the accuracy thereof, and
                        such information is subject to errors, omission, change
                        of price, rental, commission, prior sale, lease or
                        financing, or withdrawal without notice. All square
                        footage and dimensions are approximate. Exact dimensions
                        can be obtained by retaining the services of a
                        professional architect or engineer.
                      </p>
                    </section>
                  </div>

                  <div className="col-md-3 portfolio-right">
                    <h3>{data.Address1}</h3>
                    <h4>{data.Neighborhood}</h4>
                    <hr className="full-red" />

                    <p className="mt-10 caps">{data.ListingInfo} </p>

                    <hr className="full-red" />
                    <h5>OFFERED AT</h5>
                    <ul className="project-detail-box">
                      <li>
                        <strong>Asking Price:</strong>{" "}
                        {data.Price
                          ? new Intl.NumberFormat("en-US", {
                              style: "currency",
                              currency: "USD",
                              maximumFractionDigits: 0,
                              minimumFractionDigits: 0,
                            }).format(data.Price)
                          : ""}
                      </li>
                      <li>
                        <strong>Maintenance:</strong>{" "}
                        {data.Maintenance
                          ? new Intl.NumberFormat("en-US", {
                              style: "currency",
                              currency: "USD",
                              maximumFractionDigits: 0,
                              minimumFractionDigits: 0,
                            }).format(data.Maintenance)
                          : ""}
                      </li>
                      <li>
                        <strong>Financing Allowed:</strong> {data.Finance}%
                        permitted
                      </li>
                      <li>
                        <strong>Flip Tax:</strong> 3%
                      </li>
                      <li>{data.OfferDetail1}</li>
                      <li>{data.OfferDetail3}</li>
                      <li>{data.OfferDetail4}</li>
                      <li>{data.OfferDetail5}</li>
                    </ul>

                    <div className="item">
                      <img
                        className="img-fluid floorplan-thumb"
                        src={`${imageBaseUrl}${data.WebId}${floorplanItem}`}
                        alt=""
                        onClick={() => setToggler(!toggler)}
                      />
                    </div>
                    <br />
                    <h5>FEATURES</h5>
                    <ul className="project-detail-box">
                      <li>
                        <strong>Room Count:</strong> {data.Rooms}
                      </li>
                      <li>
                        <strong>Bedrooms:</strong> {data.Bed}
                      </li>
                      <li>
                        <strong>Bathrooms:</strong> {data.Bath}
                      </li>
                      <li>
                        <strong>Condition:</strong> {data.Condition1}
                      </li>
                      <li>
                        <strong>Exposures:</strong> {data.Exposures}
                      </li>
                      <li>
                        <strong>Views:</strong> {data.Views}
                      </li>
                      <div id="mortgage"></div>
                      <li>{data.Feature1}</li>
                      <li>{data.Feature2}</li>
                      <li>{data.Feature3}</li>
                      <li>{data.Feature4}</li>
                      <li>{data.Feature5}</li>
                      <li>{data.Feature6}</li>
                      <li>{data.Feature7}</li>
                      <li>{data.Feature8}</li>
                      <li>{data.Feature9}</li>
                      <li>{data.Feature10}</li>
                    </ul>
                    <br />

                    <h5>MORTGAGE CALCULATOR</h5>

                    <MortgageCalculator></MortgageCalculator>
                  </div>
                </div>{" "}
              </div>
            </section>

            <hr className="full" />

            <FunFactsArchitecture2
              title={new Date().getFullYear()}
              tagline="By The Numbers"
              paragraph1="In 2024, the Manhattan luxury market registered 1,295 contracts signed at $4 million and above, an 8.5% increase over 2023. The total volume was $11,163,926,914 compared to 2023’s $9,984,115,836. One leading indicator of the luxury market can be found in Federal Reserve data: In 2020, the total net worth of the top 1% in the US was $30.3 trillion. By the 2nd  quarter of 2024, that number grew to $46.7 trillion."
              paragraph2={`Here is how ${new Date().getFullYear()} is shaping up so far`}
              paragraph3={`FOR PROPERTIES $4 MILLION AND ABOVE`}
              paragraph4={
                <div
                  dangerouslySetInnerHTML={{
                    __html:
                      'Data sourced from The Olshan Realty <a class="underline" href="/market-report">Luxury Market Report</a>.',
                  }}
                />
              }
            />

            <div>
              <Gallery
                title="FEATURED PROPERTIES"
                tagline="Currently ON MARKET"
                classAppend="mt-150"
                filter="featured"
              />
            </div>

            <CTAOne
              tagline="Olshan Luxury Report"
              title="Highly focused. Data Driven."
              textButton="GET THE LATEST LUXURY REPORT"
              linkButton="/market-report"
              bg="color"
            >
              This report is the only one of its kind. On a weekly basis, Olshan
              publishes a report covering all the contract activity in the
              luxury market on properties at $4 million and above. The free
              report draws subscribers from all over the world, and is
              frequently quoted in the New York Times, Wall Street Journal,
              Crain's, Observer, The Real Deal and various media outlets.
            </CTAOne>
            <FooterOne />
          </Loader>
        );
      }}
    </DataFetcher>
  );
};

export default Property;
